<template>
  <div>
  <div :class="['content-list', { 'condensed' : hasFixedFooter }, { 'is-loading': activeState.isLoading }]" >
    <table ref="table" class="track-table" :class="{ 'with-footer': hasFixedFooter, 'is-sorting': viewState.isSorting }">
        <div class="overlay">
          <i class="fas fa-sync-alt fa-spin fa-4x"></i>
        </div>
        <thead>
        <tr>
            <th class="text-right">
            <i
                :class="{
                'far': true,
                'fa-square': selectedTracks.length === 0,
                'fa-check-square': selectedTracks.length === tracks.length,
                'fa-minus-square': selectedTracks.length < tracks.length
                }"

                @click.prevent="toggleSelection()"
            ></i>

            </th>
            <th v-if="showIcons"></th>
            <th v-for="header in listHeaders" :key="header.key">
            <a
                v-if="header.sortable"
                href="#"
                :class="`sort ${sort.field === header.key ? 'is-active' : ''}`"
                @click.prevent="sortBy(header.key)"
                :disabled="isLoadingTracks"
            >
                <span v-text="header.label"></span>

                <div class="sort-icons" v-if="header.key !== sort.field || !viewState.isSorting">
                    <i
                      class="fas fa-chevron-up"
                      :style="{ color: header.key === sort.field && !sort.ascending ? '#000' : '#aaa' }"
                    ></i>
                    <i
                      class="fas fa-chevron-down"
                      :style="{ color: header.key === sort.field && sort.ascending ? '#000' : '#aaa' }"
                    ></i>
                </div>

                <i v-if="header.key === sort.field && viewState.isSorting" class="fas fa-sync-alt"></i>
            </a>
            <span v-else v-text="header.label"></span>
            </th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-if="!activeState.isLoading && tracks.length === 0"
            :draggable="false"
        >
            <td colspan="99" style="padding: 1rem;">This looks empty</td>
            <td></td>
        </tr>
        <tr
            v-else
            v-for="(track, index) in tracks"
            :key="track.uid"
            :class="[{'selected':selectedFiles.tracks[track.uid]!=null, shiftable:shiftSelection.startIndex !=null && shiftSelection.startIndex == index }]"
            :draggable="track.status === 1"
            v-on:dragstart="onDragStart($event, track)"
            v-on:dragend="onDragEnd"
        >
            <td>
            <span>
                <PlayButton class="play-button mr-2" :track="track"></PlayButton>
<!--                <span v-if="!track.isComplete" v-tooltip="{ data: 'Quick upload track'}">-->
                <span v-if="!track.isComplete" >
                   <i  class="fas fa-exclamation-triangle" style="color: #5bc8fe;margin-right: 5px"></i>
                </span>
               <span v-if="track.isComplete" style="margin-left: 19px">&nbsp;</span>
                <i
                @click.prevent="toggleTrack(track, $event, index)"
                :class="['far', selectedFiles.tracks[track.uid] === undefined ? 'fa-square':'fa-check-square']"
                ></i>

            </span>
            </td>
            <td v-if="showIcons" class="text-center">
            <i
                class="type-icon fa"
                :class="trackTypesIcons[track.typeID].icon || 'fa-question'"
                v-tooltip="{ data: trackTypesIcons[track.typeID].text || '', arrowPosition: index > 0 ? 'bottom' : 'top'}"
            ></i>
            </td>
            <template v-for="header in listHeaders">
            <td :key="header.key" :class="`td-${header.size} ${header.specificClass}`">
                <template v-if="header.key === 'mood'">
                <MultiChoiceTextInput
                    :allowEdit="false"
                    :originalValue="track.mood"
                    :enumValues="Constants.moods"
                />
                </template>
                <template v-else-if="header.key === 'energy'">
                <MultiChoiceTextInput
                    :allowEdit="false"
                    :originalValue="track.energy"
                    :enumValues="Constants.energies"
                />
                </template>
                <template v-else-if="header.key === 'genderId'">
                <MultiChoiceTextInput
                    :allowEdit="false"
                    :originalValue="track.genderId"
                    :enumValues="Constants.genders"
                />
                </template>
                <template v-else-if="header.key === 'duration'">
                {{ track._duration.min }}:{{ track._duration.sec }}</template>
                <template v-else-if="header.key === 'date'">
                {{ track.publicationDate }}</template>
                <template v-else-if="header.key === 'isExplicit'">{{ track.isExplicit ? 'True' : '' }}</template>
                <template v-else-if="header.key === 'label'">
                {{ track.label ? track.label.name : '' }}</template>
                <template v-else-if="header.key === 'artists'">
                {{ track[header.key] ? track[header.key].filter(art => art.isVisible===true).map(value => value.name).join(', ') : '' }}
                <i  v-if="track.hiddenArtist" class="fas fa-info-circle" :title="'Linked artists :'+track.hiddenArtist"/>
                </template>
              <!--                v-else-if="typeof track[header.key] === 'object' && header.key !== 'tags'"-->
                <template
                v-else-if="typeof track[header.key] === 'object' && header.key !== 'tags' && header.key !== 'charts'"
                >{{ track[header.key] ? track[header.key].map(value => value.name).join(', ') : '' }}
                </template>
              <template v-else-if="typeof track[header.key] === 'object' && header.key === 'tags'" >
                <div style="display: flex;">
                  <div v-for="tag in track[header.key]" >
                    <div class="tag" :style="{backgroundColor: '#'+ tag.backColor , color:'#'+ tag.fontColor }"> {{tag.name}}</div>
                  </div>
                </div>

              </template>
              <template v-else-if="typeof track[header.key] === 'object' && header.key === 'charts'" >
                <div style="display: flex;">
                  <div v-for="chart in track[header.key]" >
                    <div class="chart" >
                      <span v-if="typeof chart.position == 'number'">
                          <span class="flag-icon flag-icon-squared" v-if="loadCountiesList.filter(country => country.id === chart.countryId)"
                                    :class="['flag-icon-' + loadCountiesList.filter(country => country.id === chart.countryId)[0].code.toLowerCase()]"
                                    v-tooltip="{data:' ' + loadCountiesList.filter(country => country.id === chart.countryId)[0].name +
                              ', Position: ' + chart.position + ', Weeks: '+ chart.weeks + ', Entry: '+ moment(chart.entry).format('DD/MM/YYYY')}"
                        ></span>&nbsp;&nbsp;
                      </span>
                        <span v-if="!(typeof chart.position == 'number')"><span class="flag-icon flag-icon-squared" v-if="loadCountiesList.filter(country => country.id === chart.countryId)"
                                    :class="['flag-icon-' + loadCountiesList.filter(country => country.id === chart.countryId)[0].code.toLowerCase()]"
                                    v-tooltip="{data:' ' + loadCountiesList.filter(country => country.id === chart.countryId)[0].name +
                              ', Charted: No' + ', Entry: '+ moment(chart.entry).format('DD/MM/YYYY')}"
                        ></span>&nbsp;&nbsp;
                      </span>

                    </div>
                  </div>
                </div>

              </template>
                <template v-else-if="header.key === 'description'">
                <span
                    ref="cellDescription"
                    class="description"
                    v-tooltip="{data: track[header.key], arrowPosition: 'top'}"
                >{{ track[header.key] }}</span>
                </template>
                <template v-else>{{ track[header.key] }}</template>
            </td>
            </template>
            <td width="32">
            <b-dropdown no-caret>
                <template slot="button-content">
                <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item
                :to="{name:'TrackHome', params: {stationUid:$route.params.stationUid, trackUid:track.uid}}"
                >Edit</b-dropdown-item>
                <b-dropdown-item
                :to="{name:'TrackMix', params: {stationUid:$route.params.stationUid, trackUid:track.uid}}"
                >Mix Points</b-dropdown-item>
                <!-- <b-dropdown-item :to="{name:'TrackConstrains', params: {stationUid:$route.params.stationUid, trackUid:track.uid}}">Constraints</b-dropdown-item> -->
              <b-dropdown-item v-on:click="moveFiles([track])" :class="{ 'cursor-not-allowed' : uploadLocked}"
                               v-tooltip="{ data: uploadLocked ? stationLockDescription : 'Upload tracks' , arrowPosition: 'right'}"  :disabled="uploadLocked">
                  Move </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item v-tooltip="{ data: uploadLocked ? stationLockDescription : 'Upload tracks' , arrowPosition: 'right'}"
                                 :disabled="uploadLocked"  :class="{ 'cursor-not-allowed' : uploadLocked}"
                                 v-on:click="openParameterSelector('showDeleteConfirmation','modalRemoval', [track])"> Delete</b-dropdown-item>
            </b-dropdown>
            </td>
        </tr>
        </tbody>
    </table>

    </div>
  <div
      class="table-footer"
      v-show="hasFixedFooter"

      draggable
      v-on:dragstart="onDragStart($event, 'selection')"
      v-on:dragend="onDragEnd"
  >
    <div class="table-footer-left">
      <a href="#" class="table-footer-button" v-on:click.prevent="removeAllSelectedTracks">
        <i class="fas fa-times fas-xl"></i>
      </a>

      <span class="table-footer-text">
            <span class="table-footer-count">{{ selectedTracks.length }}</span>
            tracks selected
        </span>
    </div>
    <div :class="['table-footer-right', hasSelectedTrack?'active':'']">
      <a href="#" :class="['table-footer-button']" :disabled="hasSelectedTrack" @click.prevent="multiAction('edit')">
        <i class="fas fa-pen fas-l" v-tooltip="{data: 'Full edit', arrowPosition: 'right'}"></i>
      </a>
      <a href="#" :class="['table-footer-button']" :disabled="hasSelectedTrack" @click.prevent="multiAction('mix')">
        <i class="fas fa-random fas-l" v-tooltip="{data: 'Edit mix point', arrowPosition: 'right'}"></i>
      </a>
      <span v-if="uploadLocked">
            <a href="#" :class="['table-footer-button', 'cursor-not-allowed']"  :disabled="hasSelectedTrack" v-tooltip="{data: uploadLocked ? stationLockDescriptionShort : 'Move files' , arrowPosition: 'right'}">
            <i  :class="['fas', 'fa-file-export','fas-l']"
            ></i>
          </a>
          <a href="#" :class="['table-footer-button' , 'cursor-not-allowed']" :disabled="hasSelectedTrack"
             disabled='true' v-tooltip="{data: uploadLocked ? stationLockDescriptionShort : 'Remove files' , arrowPosition: 'right'}">
            <i :class="['fas', 'fa-trash','fas-l']"
            ></i>
          </a>
          </span>

      <span v-if="!uploadLocked">
            <a href="#" :class="['table-footer-button', ]"  :disabled="hasSelectedTrack" v-tooltip="{data: uploadLocked ? stationLockDescriptionShort : 'Move files' , arrowPosition: 'right'}">
            <i  :class="['fas', 'fa-file-export','fas-l']"
                @click.prevent="multiAction('move')"  ></i>
            </a>
            <a href="#" :class="['table-footer-button']" :disabled="hasSelectedTrack"
               disabled='true' v-tooltip="{data: uploadLocked ? stationLockDescriptionShort : 'Remove files' , arrowPosition: 'right'}">
                <i :class="['fas', 'fa-trash','fas-l']"
                   @click.prevent="multiAction('delete')" ></i>
            </a>
          </span>

    </div>
    </div>
    <SelectorBoxes
        v-show="false"
        ref="modalBoxes"
        :stationUid="currentStationUid"
        :noModalEdit="true"
        v-on:newValue="linkToBoxes"
    />
    <TrackRemovalCard
        v-show="viewState.showDeleteConfirmation"
        ref="modalRemoval"
        :stationUid="currentStationUid"
        @onHidden="resetModalState('showDeleteConfirmation')"
    />
  </div>
</template>

<script>
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import Constants from "@/store/constants";
import Enums from "@/apis/_enums";
import Translations from "@/store/translations";
import { mapGetters, mapState, mapActions } from "vuex";
import EventBus from "@/eventbus";
import TrackRemovalCard from "@/components/Library/TrackRemovalCard.vue";
import PlayButton from "@/components/common/PlayButton.vue";
import MultiChoiceTextInput from "@/components/common/MultiChoiceTextInput.vue";
import moment from "moment";
import Tooltip from "@/components/common/Tooltip.vue";
import SelectorBoxes from "@/components/Library/SelectorBoxes.vue";

export default {
  name: "TrackQuickList",
  components: {
    PlayButton,
    TrackRemovalCard,
    MultiChoiceTextInput,
    Tooltip,
    SelectorBoxes
  },
  props: {
    isAdvancedSearch : {type:Boolean, default:false},
    fileType: { required: true },
    files: { required: false, default: null },
    showIcons: { default: false, type: Boolean },
  },
  created() {
    console.log('created')
    EventBus.$on("onSearchClose", this.closeSearch);
    EventBus.$on("onTracksSearch", this.loadTracks);
    EventBus.$on("onTrackUploaded", this.onTrackUploaded);
    EventBus.$on("isStationLockedBus", this.getLockData);
    this.$store.dispatch("tracks/loadCountiesList")
    if (this.uploadLocked === null ){
      this.uploadLocked = this.uploadLockedStore();
    }
  },
  beforeDestroy() {
    console.log('beforeDestroy')
    EventBus.$off("onSearchClose", this.closeSearch);
    EventBus.$off("onTracksSearch", this.loadTracks);
    EventBus.$off("onTrackUploaded", this.onTrackUploaded);
    EventBus.$off("onTracksDeleteEnded", this.removeFilesFromList);
    EventBus.$off("isStationLockedBus", this.getLockData);
  },
  mounted() {
    console.log('mounted')
    this.removeAllSelectedTracks();
    if (this.isAdvancedSearch && (this.filters||[]).length==0)
    {
        this.$router.push({ name: 'LibraryAdvancedSearchQuery' });
    }
    EventBus.$on("onTracksDeleteEnded", this.removeFilesFromList);
    // EventBus.$on("onTracksDeleteEnded", this.onTrackRemovalEnded);
    this.setDefaultSorting();
    if (!this.isAdvancedSearch)
      this.loadTracks();
    this.countries =this.$store.state.tracks.countries;
    console.log(this.countries)
  },
  computed: {
    ...mapActions('tracks', ["loadCountiesList"]),
    ...mapState({
      loadCountiesList(state){return  state.tracks.countries},
      searchUid() {return  this.activeState.searchUid;},
      activeState(state){ return this.isAdvancedSearch ? state.advancedSearch : state.Search; },
      hasSearch(state){ return state.viewState.hasSearch; },
      isLoadingTracks(state) { return  this.activeState.isLoading; },
      searchResult(state) { return this.activeState.trackList },
      pagination(state) { return this.activeState.pagination; },
      filters () {
        return this.activeState.filters; // not defined for quick search
      }
    }),
    tracks() {
       return (this.searchResult || []).map(track => ({
          ...track,
            _duration: this.getMinSec(track.duration),
            publicationDate: new Date(track.publicationDate).toLocaleDateString("fr-BE"),
        }))
    },
    listHeaders(){ return this.buildHeaderList();},
    currentStationUid() {  return this.$route.params.stationUid; },
    Translations: () => Translations,
    trackTypes() { return Enums.TrackTypes; },
    hasSelectedTrack(){
      return Object.keys(this.selectedFiles.tracks).length > 0;
    },
    selectedTracks () {
      return Object.values(this.selectedFiles.tracks)
    },
    hasFixedFooter () {
      return this.selectedTracks.length > 0;
    },
    trackTypesIcons() {
      const typesIcons = [];

      Object.values(Constants.trackTypes).forEach(type => {
        typesIcons[type.value] = type;
      });

      return typesIcons;
    }
  },
  watch: {
    fileType: function() {
      console.log("FileType Changed")
      if (!this.$route.query.search) {
        EventBus.$emit("closeSearch");
      }
      this.loadTracks(1);
    },
    "$route.params.stationUid": function(value) {
      console.log('watch')
      this.loadTracks(1);
    },
  },

  data() {
    return {
      Constants,
      moment,
      uploadLocked: null,
      stationLockDescriptionShort: Constants.stationLockedLabelShort,
      stationLockDescription: Constants.stationLockedLabel
      ,
      viewState: {
        //isLoadingTracks: false,
        isSorting: false,
        isInSearch: false,
        showDeleteConfirmation: false
      },
      sort: {
        field: "artist",
        ascending: true
      },
      shiftSelection:
      {
          startIndex:null, endIndex:null, isSelected:false
      },
      lastPromise: null,
      selectedFiles: {
        records: {},
        tracks: {},
        updateTime: new Date()
      },
      isSearchTriggered: false,
      descriptionWidth: 0,
      countries: []

    };
  },

  methods: {
    ...mapState('tracks', ['uploadLockedStore']),
    // REVIEWED
    getLockData(value) {
      console.log(value)
      this.uploadLocked = value;
    },
    multiAction(code)
    {

      if (!this.hasSelectedTrack) return false;
      switch(code){
        case"edit": this.editTracksMeta();break;
        case"mix": this.editTracksMix();break;
        case"move": this.moveFiles ("selected");break;
        case"delete": this.openParameterSelector('showDeleteConfirmation','modalRemoval', this.selectedTracks);break;
      }
    },

    // REVIEWED
    async linkToBoxes(type, targetBoxes)
    {
        for(var idx in targetBoxes)
        {
            let box = targetBoxes[idx];
            await this.$store.dispatch("Boxes/linkMultipleTrack",
            {
                stationUid: box.stationUid,
                boxUid: box.uid,
                trackUids:Object.keys(this.selectedFiles.tracks)
            })
            await this.refreshBoxStats(box.stationUid,box.uid)
        }
    },
    async refreshBoxStats(stationUid, boxUid){
      if (stationUid != this.$route.params.stationUid) return;
      await this.$store.dispatch("refreshBoxStats",
      {
          stationUid: this.$route.params.stationUid,
          boxUid: boxUid,
      })
    },
    // REVIEWED
    buildHeaderList(){
      return [
            this.fileType == Constants.trackTypes.MUSIC || this.fileType == Constants.trackTypes.FILLER
              ? { label: "Artist", key: "artists", sortable: true, size: "xl" }
              : { label: "Author", key: "artist", sortable: true, size: "xl" },
              //---------------------------------------------------------------------------------------------
            { label: "Title", key: "title", sortable: true, size: "xl" },
            { label: "Explicit", key: "isExplicit", sortable: true, size: "m" },
            { label: "Styles", key: "styles", sortable: false, size: "xl" },
            { label: "Languages", key: "languages", sortable: false, size: "xl" },
            { label: "Label", key: "label", sortable: true, size: "xl" },
            {
              label: "Info",
              key: "description",
              sortable: true,
              size: "xl"
            },
            { label: "BPM", key: "bpm", sortable: true, size: "m" },
            { label: "Year", key: "year", sortable: true, size: "m" },
            { label: "Date", key: "publicationDate", sortable: true, size: "l" },
            { label: "Mood", key: "mood", sortable: true, size: "auto", specificClass:"mlt" },
            { label: "Energy", key: "energy", sortable: true, size: "auto", specificClass:"mlt"},
            { label: "Gender", key: "genderId", sortable: true, size: "auto", specificClass:"mlt" },

            { label: "Duration", key: "duration", sortable: true, size: "m" },
            { label: "Instruments", key: "instruments", sortable: true, size: "xl" },
            { label: " % Vocal-Instruments", key: "vocalInstruments", sortable: true, size: "xl" },
            { label: "Charts", key: "charts", sortable: true, size: "l" },
            { label: "Tags", key: "tags", sortable: true, size: "xl" },
          ]
    },
    onTrackUploaded(newTrack) {
      if (!newTrack.isFilled) {
        this.$router.push({
          name: "LibraryPending",
          params: { stationUid: this.$route.params.stationUid }
        });
      }

    },

    // REVIEWED
    moveFiles(tracks) {
        let files = tracks;

        if (tracks === "selected") {
            files = Object.keys(this.selectedFiles.tracks).map(
                prop => this.selectedFiles.tracks[prop]
            );
        }
        //this.$refs.moveTracks.show(files);
        this.$refs.modalBoxes.show(files);
    },
    editTracksMeta() {
      const tracks = [];

      Object.keys(this.selectedFiles.tracks).map(item => {
        tracks.push(this.selectedFiles.tracks[item].uid);
      });

      this.$store.commit("tracks/updateTracks", tracks);
      this.$store.commit("tracks/updatePrevPage", this.$route);
      this.$store.commit("tracks/updateClose", true);

      this.$router.push({
        name: "TrackHome",
        params: {
          stationUid: this.$route.params.stationUid,
          trackUid: tracks[0]
        }
      });
    },
    editTracksMix() {
      const _tracks = [];

      Object.keys(this.selectedFiles.tracks).map(item => {
        _tracks.push(this.selectedFiles.tracks[item].uid);
      });

      this.$router.push({
        name: "TrackMix",
        params: {
          stationUid: this.$route.params.stationUid,
          trackUid: _tracks[0]
        },
        query: {
          track_ids: JSON.stringify(_tracks)
        }
      });
    },
    fetchTracks(resetPagination = false) {
      //if (resetPagination) {
      //  this.currentPagination.page = 1
      //}
      //if (this.isAdvancedSearch) {
      //  return
      //}

      const searchTerm = this.$route.query.search;

      var api = Apis.library.tracks.search;
      const params = {
        stationUid: this.currentStationUid,
        sortField: this.sort.field,
        sortAscending: this.sort.ascending,
        trackType: (this.fileType || Constants.trackTypes.UNDEFINED).key,
        searchTerm: searchTerm,
        pageSize: 100
      }

      if (searchTerm) {
        this.viewState.isInSearch = true;
      }

      return HTTP.post(api, {
          ...params,
          page: this.currentPagination.page
        }).then(() => {
            this.viewState.isSorting = false
        })
    },

    // loadLastTracks(resetPagination = false) {
    //   const promise = this.fetchTracks(resetPagination)
    //   this.lastPromise = promise

    //   return new Promise((resolve, reject) => {
    //     promise.then(result => {
    //       if (promise === this.lastPromise) {
    //         this.lastPromise = null

    //         resolve(result)
    //       }
    //     })
    //   })
    // },

    async loadTracks(page = null) {
      this.viewState.isLoadingTracks = true
      this.removeAllSelectedTracks()
      const searchTerm = this.$route.query.search;
      if (this.isAdvancedSearch) {
        console.log('-------------------advancedSearch loadTracks')
        await this.$store.dispatch('advancedSearch/launch', {
              stationUid: this.currentStationUid,
              filters: this.filters,
              sortField: this.sort.field,
              sortAscending: this.sort.ascending,
              pageSize: (this.pagination || { pageSize: 100 }).pageSize,
              page : page || 1
        });
      } else {
        console.log('-------------------search loadTracks')
        await this.$store.dispatch('Search/launch', {
            stationUid: this.currentStationUid,
            sortField: this.sort.field,
            sortAscending: this.sort.ascending,
            trackType: (this.fileType || Constants.trackTypes.UNDEFINED).key,
            searchTerm: searchTerm,
            pageSize: (this.pagination || { pageSize: 100 }).pageSize,
            page : page || 1
        })
      }

      this.viewState.isSorting = false
    },
    removeAllSelectedTracks() {
      this.selectedFiles.tracks = {};
    },
    onDragStart(e, track) {
      if(Object.keys(this.selectedFiles.tracks).length == 0)
      {
        e.preventDefault();
        return;
      }
      // Fix for Firefox
      e.dataTransfer.setData("text/html", "");
      const tracks = [];
      const $ghost = document.body.querySelector("#drag-ghost");

      if (
        (this.selectedFiles.tracks[track.uid] != null &&
          this.selectedTracks.length > 1) ||
        track === "selection"
      ) {
        $ghost.innerHTML = `${this.selectedTracks.length} files selected`;
        tracks = this.selectedTracks
      } else {
        $ghost.innerHTML = track.title;
        tracks.push(track);
      }

      this.$store.dispatch("dnd/update", { type: "tracks", item: tracks });
      e.dataTransfer.setDragImage($ghost, 0, 0);
      EventBus.$emit("dragStart");
    },
    onDragEnd(e) {
      EventBus.$emit("dragEnd");
    },
    multipleToggle(){
      let multiSelect = {
          startIndex:Math.min(this.shiftSelection.startIndex, this.shiftSelection.endIndex),
          endIndex:Math.max(this.shiftSelection.startIndex, this.shiftSelection.endIndex),
          isSelected:this.shiftSelection.isSelected
      }
      console.log(JSON.stringify(multiSelect))
      let i = 0
      this.tracks.filter(tr => {
          let elligible = i>= multiSelect.startIndex && i<=multiSelect.endIndex;
          console.log(i,  elligible)
          i++;
          return elligible;
      })
      .map(track =>
      {
          track.isSelected = this.shiftSelection.isSelected;
          if (this.shiftSelection.isSelected) {
            this.$set(this.selectedFiles.tracks, track.uid, track);
          } else {
            this.$delete(this.selectedFiles.tracks, track.uid);
          }
      })
    },
    toggleTrack(track, event, index) {
      track.isSelected = !track.isSelected;

      if (event.shiftKey){
          if (this.shiftSelection.startIndex != null){
              this.shiftSelection.endIndex = index;
              this.multipleToggle()
              this.shiftSelection = {isSelected:track.true, startIndex:null, endIndex:null}
              return;
          }
          else
          {
              console.log("End SHIFT Index")
              this.shiftSelection.isSelected = track.isSelected;
              this.shiftSelection.startIndex = index;
              this.shiftSelection.endIndex = null;
          }
      }
      else{
          this.shiftSelection = {isSelected:track.true, startIndex:null, endIndex:null}
          console.log("Set SHIFT Operation", JSON.stringify(this.shiftSelection))
      }

      if (this.selectedFiles.tracks[track.uid] != null) {
        this.$delete(this.selectedFiles.tracks, track.uid);
      } else {
        this.$set(this.selectedFiles.tracks, track.uid, track);
      }
    },
    toggleSelection: function() {
      if (this.selectedTracks.length === 0) {
        var selection = {};
        let _tracks = this.tracks ;
        if (_tracks) {
          _tracks.forEach(tr => {
            selection[tr.uid] = tr;
          });
        }
        this.selectedFiles.tracks = selection;
      } else {
        this.selectedFiles.tracks = {};
      }
    },
    async removeFilesFromList(uids) {
      if (uids.length === 0) {
        return
      }

      this.removeAllSelectedTracks()
      console.log('removeAllSelectedTracks')
      this.loadTracks(this.activeState.pagination.page);
      await this.$store.dispatch(
        "loadStationBoxes",
        this.$route.params.stationUid
      );
    },
    handleSettings(e) {
      const trackUid = e.uid;
      const stationUid = this.$route.params.stationUid;
      this.$router.push({
        name: "TrackHome",
        params: {
          stationUid,
          trackUid
        }
      });
    },
    resetModalState(toggler) {
      this.$set(this.viewState, toggler, false);
    },
    openParameterSelector(toggler, selectorName, tracks) {
      if (!tracks || tracks.length === 0) return;
      this.viewState[toggler] = true;
      try {
        var modalSelector = this.$refs[selectorName];
        if (modalSelector) {
          modalSelector.editForTracks(tracks);
        }
      } catch (e) {
        console.log("exc:", e);
      }
    },
    sortBy(field) {
      this.viewState.isSorting = true
      if (this.sort.field === field) {
        this.sort.ascending = !this.sort.ascending;
      } else {
        this.sort.field = field;
        this.sort.ascending = true;
      }

      localStorage.setItem("LIBRARY_SORTING", JSON.stringify(this.sort));
      console.log('sortBy')
      this.loadTracks(this.activeState.pagination.page);
    },
    setDefaultSorting() {
      const storedSorting = window.localStorage.getItem("LIBRARY_SORTING");
      if (storedSorting) {
        this.sort = JSON.parse(storedSorting);
      }
    }
  }
};


</script>

<style lang="scss" scoped>
i.fa-info-circle{
  position: absolute;right: 10px;top:12px;
  color:var(--COLOR_BRAND);
  cursor: help;
}
.content-list {
  max-height: 100%;
}
div.content-list.condensed{
  height: calc(100% - 35px);
}
table {
  // margin-top: -15px;
  width: 100%;
  font-weight: 400;
  color: #292c33;

  &.is-dragging {
    td,
    td * {
      pointer-events: none !important;
    }
  }
}

.track-table .overlay {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  color: white;
  cursor: progress;
  background-color: rgba(0,0,0, .15);
  padding-top: 150px;
  overflow: hidden;
  z-index: 9999;
}

.content-list.is-loading {
  overflow: hidden;
  .track-table {
    .overlay { display: flex; align-items: center; justify-content: center; }

    tbody {
      overflow: hidden;
    }
  }
}

thead,
thead tr:nth-child(1) th:not(:first-child) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2000;
}

thead tr th {
  background: white;
}

/* thead, */
thead tr:nth-child(1) th {
  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #d2d2d2;
  }
}

td,
th {
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  position:relative;
  vertical-align: middle;
  &.td-s {
    min-width: 70px;
  }

  i {
    color: #d2d2d2;
  }
}

td {
  &:not(:last-child) {
    padding: 0 12px;
  }

  &:first-child {
    padding-left: 8px;
    padding-right: 12px;
  }

  &:not(:last-child) {
    border-right: 1px dashed #d2d2d2;
  }

  &:nth-last-child(2) {
    border-right: 0;
  }
  &.mlt{
    text-align: center;
  }
  span {
    white-space: nowrap;

    .decorator {
      margin-right: 10px;
    }
  }

  button {
    background: none;
    border: 0;

    &::after {
      content: none;
    }

    i {
      transition: color 0.2s ease-in-out;
      font-size: 18px;
    }
  }
}

th {
  color: #aaaaaa;
  padding: 12px;
  z-index: 1600;
}

th:first-child,
th:last-child {
  top: 0;
}

th:first-child,
td:first-child {
  background: white;
  color: #aaa !important;
  left: 0;
  position: sticky;
  z-index:1000;
  vertical-align: middle;
  border-right: 0;

  &:before {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: #d2d2d2;
  }

  i {
    color: #aaa;
  }
}

td:last-child {
  background: white !important;
  z-index: 1000;
}

th:last-child,
td:last-child {
  background: white;
  right: 0;
  position: sticky;
  z-index:1000;
  vertical-align: middle;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: #d2d2d2;
  }
}

tbody tr, .virtual-list tr {
  color: #292c33;
  font-size: 13px;
  line-height: 16px;
  border-bottom: 1px solid #d2d2d2;
  &.shiftable{
    border-bottom:1px solid var(--COLOR_BRAND) !important;
  }
  &:last-child {
    border-bottom: 0;
  }
}

.track-table {
  .btn.dropdown-toggle {
    border: 0;
    background: none;

    &::after {
      content: none;
    }
  }

  &.is-sorting {
    tbody {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}

// .track-table.with-footer {
//   margin-bottom: 54px;
// }

.sort {
  display: flex;
  cursor: pointer;
  transition: color 0.15s ease-in-out;
  color: #aaaaaa;
  font-weight: 400;

  &[disabled] {
    pointer-events: none;
  }

  &.is-active {
    color: #000;
  }

  &:hover {
    text-decoration: none;
  }

  &-icons {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-left: 5px;

    i {
      font-size: 10px;
      height: 8px;
    }
  }

  @keyframes sorting {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .fa-sync-alt {
    align-self: center;
    font-size: 12px;
    margin-left: 5px;
    transform-origin: 50% 50%;
    animation: sorting 1s linear infinite;
  }
}
div.menu-expanded{
  .table-footer{
    left: 300px;
    transition: all .5s ease-in-out;
  }
}
.table-footer {
  position: sticky;
  height: 45px;
  left: 10px;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  z-index: 1200;
  right: 10px;
  align-items: center;
  transition: all .5s ease-in-out;
  .td {
    flex-shrink: 0;
    padding: 16px 12px;
    vertical-align: middle;
    color: #fff;
    &:first-child {
      padding-left: 15px;
    }
    &:last-child {
      display: flex;
      min-width: 142px;
      padding-left: 22px;
      a + a {
        margin-left: 20px;
      }
    }
    button.option {
      color: #fff;
    }

  }
  .fas {
    &.fas-l {
      font-size: 18px;
    }
    &.fas-xl {
      font-size: 24px;
    }
  }
}

.table-footer-left,
.table-footer-right {
  display: flex;
  align-items: center;
  padding: 0 15px;
  color: #fff;
  .fas {
    display: block;
  }
}

.table-footer-right {
  position: absolute;
  right: -300px;
  transition:all 0.5s ease-in-out;
  &.active {
    right:0;
    background: transparent;
    transition:all 0.5s ease-in-out;
  }
  .table-footer-button {
    margin-left: 20px;
  }
}

.table-footer-text {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
}

.table-footer-count {
  display: inline-block;
  padding: 2px 10px 4px;
  margin-right: 4px;
  border-radius: 20px;
  background-color: rgba(#000, 0.2);
}

.table-footer-button {
  display: inline-block;
  transition: opacity 0.2s ease-in-out;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  vertical-align: middle;
  &:hover {
    opacity: 0.6;
  }
  + .table-footer-text {
    margin-left: 23px;
  }
}
.description {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 200px;
}
  .track-list__root{
    position: relative;

    .pagination__root{
      position: fixed;
      bottom: 70px;
      left: 50%;
      transform: translateX(0);
      border-radius: 0.25rem;
      max-width: unset;
    }
  }
  .b-pagination li {
    padding: 0;
    a{
      border-top: none;
      border-bottom: none;
    }
    a, span{
      height: 100%;
    }
    &.active {
      a{
        border-color: #dee2e6;
      }
    }
  }

.pointer-events-none {
  pointer-events: none;
}
.cursor-not-allowed {
  cursor : not-allowed;
}
.tag{
  padding:5px;border-radius: 7px ;margin-right: 3px
}
</style>
